import en from "@/i18n/en";
import fr from "@/i18n/fr";
import de from "@/i18n/de";

export const LOCALES = ["en", "fr", "de"];
export const DEFAULT_LOCALE = "en";

const bundles = { en, fr, de };

export const isLocale = (l) => LOCALES.includes(l);

export const messagesFor = (locale) => bundles[locale] || bundles[DEFAULT_LOCALE];

/** Get a nested key using dot-notation from the message bundle. */
export const getMessage = (locale, path, fallback = "") => {
  const bundle = messagesFor(locale);
  const parts = path.split(".");
  let cur = bundle;
  for (const p of parts) {
    if (cur && typeof cur === "object" && p in cur) {
      cur = cur[p];
    } else {
      return fallback;
    }
  }
  return cur == null ? fallback : cur;
};
